import React, { useEffect } from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import { TabMenuItems } from '../../models/components/lesson-menu-tab';
import Translator from '../../core/i18n';
import "./hideScrollbar.css";
import { UserType } from '../../models/pages/login.d';
import { Log } from 'ng2-logger';
import { ModuleItems } from '../../models/enums/moduleItems';


const _logger = Log.create('scrollablemenu.tsx');
const T = Translator.create();
function App({ tabOnClick, user, refreshCourseContent, courseContentMenuType, moduleItems }: Readonly<{ tabOnClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void, user: number, refreshCourseContent: () => void, courseContentMenuType: any, moduleItems: any }>) {
    const [items, setItems] = React.useState(
        [
            { label: T.t('r_lesson_homepage_courseContent'), href: '#courseContent', id: '1', tabMenu: TabMenuItems.courseContent, isActive: true },
            { label: T.t('r_menu_announcements'), href: '#', id: '2', tabMenu: TabMenuItems.announcements, isActive: false },
            { label: T.t('r_lesson_homepage_discussion'), href: '#', id: '3', tabMenu: TabMenuItems.discussion, isActive: false },
            { label: T.t('r_lesson_homepage_files'), href: '#', id: '4', tabMenu: TabMenuItems.files, isActive: false },
            { label: T.t('r_lesson_homePage_studentList'), href: '#', id: '5', tabMenu: TabMenuItems.studentList, isActive: false },
        ]
    );

    const [itemsStudent, setItemsStudent] = React.useState(
        [
            { label: T.t('r_lesson_homepage_courseContent'), href: '#courseContent', id: '1', tabMenu: TabMenuItems.courseContent, isActive: true },
            { label: T.t('r_menu_announcements'), href: '#', id: '2', tabMenu: TabMenuItems.announcements, isActive: false },
            { label: T.t('r_lesson_homepage_discussion'), href: '#', id: '3', tabMenu: TabMenuItems.discussion, isActive: false },
        ]
    );

    const handleActiveClick = (id: string) => {
        const newItems = items.map((item) =>
            item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
        );

        const newStudentItems =itemsStudent.map((item) =>
        item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
    );

        if(user !== UserType.Student) {
            setItems(newItems);
        }
        else {
            setItemsStudent(newStudentItems);
        }

    };

    useEffect(() => {
        if(!courseContentMenuType){
            refreshCourseContent();
        }

    }, [courseContentMenuType])

    return (
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} >
            {
            user === UserType.Student ?

            itemsStudent.map((item) => (
                ((item.id !== '2' && item.id !== '3') || moduleItems.includes(ModuleItems.Announcement) || moduleItems.includes(ModuleItems.Activities_Forum)) && 
                <li aria-hidden={true} key={item.id} onClick={() => { handleActiveClick(item.id) }} style={{ display: 'inline-block' }}>
                    {
                            <span style={{padding: '14px 0px 0px 0px'}}>
                                <a onClick={tabOnClick} id={item.id} data-toggle="tab" role="tab" data-tabparam={item.tabMenu} style={{ display: 'inline-block' , marginLeft: '5px',fontSize: '1em',lineHeight: '24px', marginRight: '5px', color: 'rgba(50, 50, 49, 0.8)', textAlign: 'center', padding: '14px 0px 0px 0px', borderBottom: item.isActive ? '2px solid black' : 'none' , textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',textDecoration: 'none' }} href={item.href}>{item.label}</a>
                            </span>

                    }

                </li>
            ))
                    :

                    items.map((item) => (
                        ((item.id !== '2' && item.id !== '3') || moduleItems.includes(ModuleItems.Announcement) || moduleItems.includes(ModuleItems.Activities_Forum)) && 
                        <li aria-hidden={true} key={item.id} onClick={() => { handleActiveClick(item.id) }} style={{ display: 'inline-block' }}>
                            {

                                    <span style={{padding: '14px 0px 0px 0px'}}>
                                        <a onClick={tabOnClick} id={item.id} data-toggle="tab" role="tab" data-tabparam={item.tabMenu} style={{ display: 'inline-block' , marginLeft: '5px',fontSize: '1em',lineHeight: '24px', marginRight: '5px', color: 'rgba(50, 50, 49, 0.8)', textAlign: 'center', padding: '14px 0px 0px 0px', borderBottom: item.isActive ? '2px solid black' : 'none' , textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',textDecoration: 'none' }} href={item.href}>{item.label}</a>
                                    </span>

                            }

                        </li>
                    ))
        }
        </ScrollMenu>
    );
}

function LeftArrow() {

    const { isFirstItemVisible, scrollPrev } =
        React.useContext(VisibilityContext);

    return (
        <i style={{ marginTop: '15px', width: '12px',color: 'rgba(50, 50, 49, 0.8)',marginRight: '8px' }} onClick={() => scrollPrev()} className="material-icons">arrow_back_ios</i>
    );
}

function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

    return (
        <i
            style={{ marginTop: '15px',color: 'rgba(50, 50, 49, 0.8)'}}
            onClick={() => scrollNext()}
            className="material-icons">arrow_forward_ios
        </i>
    );
}

export default App;